export const import_theme_atom_to_client_service = {
  error_unknown: 'Có lỗi trong hệ thống',
  import_error: 'Qúa trình nhập lỗi',
  import_success: 'Nhập thành công',
  importing: 'Đang nhập',
} as const;
